// DATASET_1 is used for summary, conclusion and what to watch out for section
// DATASET NAME = 16星耀在159宫位解读
export const DATASET_1 = {
  紫微: {
    type: "帝王星",
    label: "🪄 统御策局者 ｜人生蓝图操盘手",
    命宫: {
      title: "🔱 紫微（命宫）｜帝王星",
      description:
        "你天生有王者气场，骨子里就是要带头的人。\n你的人设不适合服从太久，你适合创造方向、设定标准。\n越早意识到“我不是来被指挥的”，你会越早翻盘。",
      strengths:
        "Strong presence, Highly responsible, Exceptional at organizing and managing tasks, Reliable in leadership, Able to inspire confidence in others",
      cautions: "Prideful, Distant, Demanding",
      next_focus: "Learn to make decisions, use a stable heart to raise a team",
      quote: "Your life is not meant to please, but to lead.",
    },
    财帛宫: {
      title: "🔱 紫微（财帛宫）",
      description:
        "你适合打造属于自己系统的商业模式，\n只靠一个客户、一个平台，你会憋坏。你需要的是“掌控感”。\n你能聚财，但更擅长“设规则让钱自己滚进来”。",
      earning_methods: "打造自己的商业系统、有领导的金钱管道",
      financial_risks: "太依赖权贵，或过度投资门面、排场",
      focus_areas: "多管道收入／组团队赚钱／建立金钱系统",
      quote:
        "You are not a money-making worker, you are the master of your asset empire.",
    },
    官禄宫: {
      title: "🔱 紫微（官禄宫）｜帝王星",
      description:
        "你适合做有头衔、有权力的位置，\n如企业高管、组织领导、政策制定者等。\n你的事业发展需要建立自己的权威和影响力。",
      career_traits: "企业高管、组织领导、政策制定者",
      career_pitfalls: "过于追求权力，忽视团队协作",
      focus_areas: "建立权威的同时，注重团队建设和协作",
      quote:
        "Your leadership is the core of your career, leading a team to create glory.",
    },
  },
  天府: {
    type: "掌财星",
    label: "💰 财富聚核者 ｜资源系统建构师",
    命宫: {
      title: "🏛️ 天府（命宫）｜掌财星",
      description:
        "你天生稳重、可靠，擅长管理和规划。\n你对资源的掌控能力强，适合担任管理和协调的角色。\n越早意识到“稳定是你的优势”，你会越早建立自己的王国。",
      strengths:
        "Stable under pressure, Consistently reliable, Excellent at managing systems and processes, Dependable in decision-making, Methodical in execution",
      cautions: "Conservative, Unoriginal",

      next_focus:
        "On the basis of stability, try to innovate and break through",
      quote: "Your stability is the foundation of your success",
    },
    财帛宫: {
      title: "🏛️ 天府（财帛宫）｜掌财星",
      description:
        "你适合从事需要管理和规划的工作，\n如财务管理、资源配置、项目管理等。\n你的收入来源稳定，但需要避免过于保守。",
      earning_methods: "财务管理、资源配置、项目管理",
      financial_risks: "过于保守，错失机会",
      focus_areas: "在稳健的基础上，适度冒险，抓住机会",
      quote: "Your stability is the foundation of your success",
    },
    官禄宫: {
      title: "🏛️ 天府（官禄宫）｜掌财星",
      description:
        "你适合从事需要管理和协调的职业，\n如企业管理、行政管理、项目管理等。\n你的职业发展需要建立稳定的管理体系。",
      career_traits: "企业管理、行政管理、项目管理",
      career_pitfalls: "过于保守，缺乏创新",
      focus_areas: "在稳定的基础上，尝试创新和突破",
      quote:
        "Your management skills are the core of your career, innovation is the driving force of your career.",
    },
  },
  天相: {
    type: "协调星",
    label: "🤝 平衡整合者 ｜人脉关系经营师",
    命宫: {
      title: "⚖️ 天相（命宫）｜协调星",
      description:
        "你天生温和、善于协调，擅长处理人际关系。\n你适合担任协调和管理的角色，建立和谐的团队氛围。\n越早意识到“协调是你的天赋”，你会越早发挥自己的影响力。",
      strengths:
        "Gentle demeanor, Skilled at coordination, Strong interpersonal connections, Empathetic in communication, Effective at building harmonious relationships",
      cautions: "Over-accommodating",

      next_focus: "Focus on yourself while coordinating others",
      quote:
        "Your coordination skills are the source of your influence, focusing on yourself can better serve others.",
    },
    财帛宫: {
      title: "👑 天相（财帛宫）",
      description:
        "你靠贵人、合作、信任感赚钱，适合做服务、品牌经营、信任变现。\n你不能硬卖，反而“人设＋陪伴＋专业”最能带财进门。",
      earning_methods: "品牌服务、咨询顾问、教学辅导、客户关系经营",
      financial_risks: "太怕要价、太讲人情、被人情消费",
      focus_areas: "清楚表达价值／创造信任通路／定价别再退",
      quote:
        "You are not a product seller, you are a soul brand that people buy安心。",
    },
    官禄宫: {
      title: "⚖️ 天相（官禄宫）｜协调星",
      description:
        "你适合在“人际核心”中起关键作用：你不是舞台上的主角，但你是让舞台顺利运转的那个人。\n你的细腻、稳定、平衡力强，适合带团队、管流程、统筹资源。",
      career_traits:
        "客户关系管理／内部行政主管／人事／教育系统中层干部／助理顾问类岗位／政府单位",
      career_pitfalls: "怕冲突导致让步过多／不善拒绝而被压榨",
      focus_areas: "练习边界感／明确职掌与KPI／打造可复制的协作模式",
      quote:
        "You are the quiet force that keeps the world running smoothly, without conflict, yet remarkably stable.",
    },
  },
  武曲: {
    type: "执行星",
    label: "⚔️ 铁律执行者 ｜行动力实现系",
    命宫: {
      title: "⚔️ 武曲（命宫）｜执行星",
      description:
        "你是天生的执行者，行得快、撑得久、做得深。你对时间、效率、成果特别有意识。\n你不是花拳绣腿型，你是靠干、靠拼、靠狠劲活出价值的人。",
      strengths:
        "Highly effective in execution, Disciplined and focused, Grounded in stability, Driven by clear goals, Consistent in performance",
      cautions: "Emotionally reserved",

      next_focus: "Learn to express yourself and be seen and valued",
      quote:
        "You are not a tool, you are a hard-core pioneer who breaks the value loop.",
    },
    财帛宫: {
      title: "⚔️ 武曲（财帛宫）｜执行星",
      description:
        "你是靠专业＋效率＋实干赚到钱的类型。你对数字、预算、报酬特别敏感，是超强绩效导向型赚钱人。",
      earning_methods: "项目管理、金融操作、流程优化、商业实战、投资评估",
      financial_risks: "低估自己价值／用体力换钱／沉迷细节而忽略大局",
      focus_areas: "建立属于自己的「高价服务系统」，提升每小时单位产值",
      quote: "You are not a salary earner, you are a result-driven operator.",
    },
    官禄宫: {
      title: "⚔️ 武曲（官禄宫）｜执行星",
      description:
        "你适合被授权、扛责任、讲 KPI 的位置。你不适合等、拖、讨论太久的环境，适合结果导向、标准明确的工作。",
      career_traits:
        "企业中高层、执行长、金融、军警、供应链、财务分析、专案管理",
      career_pitfalls: "压过主管、推不开团队、太用力失去弹性",
      focus_areas: "打造「带人系统」而不是「做事系统」，让你从个人强转团队强",
      quote:
        "You are not just to complete tasks, you are here to build a performance system.",
    },
  },
  天机: {
    type: "智多星",
    label: "🧠 策略预判者 ｜智慧流通架构师",
    命宫: {
      title: "🧠 天机（命宫）｜智多星",
      description: "",
      strengths:
        "Quick to react, Deeply analytical, Strong in strategic planning, Adaptable in changing situations, Mentally agile and insightful",
      cautions: "Overthinks, Indecisive",

      next_focus: "Start executing比思考更重要，练习让一个想法跑到终点",
      quote:
        "You are not too slow, you are using your time to predict the future. It's time to take action.",
    },
    财帛宫: {
      title: "🧠 天机（财帛宫）｜智多星",
      description: "",
      earning_methods:
        "顾问型收入、逻辑型教学、数据分析、策略搭建、线上系统变现",
      financial_risks: "想太多导致错失入场机会，方案变来变去影响财务稳定",
      focus_areas: "选一个最有机会长期跑赢的方向深耕，别把能量分给太多细枝末节",
      quote:
        "Your money is not fast or slow, it's whether you are doing the right thing at the right time.",
    },
    官禄宫: {
      title: "🧠 天机（官禄宫）｜智多星",
      description: "",
      career_traits:
        "产品设计师、策略顾问、数据分析师、UX专家、研究员、教育者、系统整合者",
      career_pitfalls: "不爱管人／缺乏表达，容易被忽视",
      focus_areas: "搭配表达型合伙人／打造个人策略品牌／建立高单价智力服务系统",
      quote:
        "You are the person who can break down the world, you don't need to change everything, you just need to design a smarter rule.",
    },
  },
  文曲: {
    type: "感性艺术星",
    label: "🎨 灵感催化者 ｜情感共鸣引导者",
    命宫: {
      title: "🎼 文曲（命宫）｜感性艺术星",
      description:
        "你是艺术气质型人格，情感丰富、审美力强、感受力极高。你很会感人，也常常容易“被情绪影响”。\n你适合传达美、传递氛围、写下感觉。",
      strengths:
        "Emotionally expressive, Highly creative, Artistically talented, Skilled in evocative writing, Deeply imaginative",
      cautions: "Overemotional, Self-pitying",

      next_focus: "培养稳定输出能力／情绪不再控制你，而是被你转化成灵感",
      quote:
        "You are not a glass heart, you are a container of the whole galaxy.",
    },
    财帛宫: {
      title: "🎼 文曲（财帛宫）｜感性艺术星",
      description:
        "你最适合“把感觉变成产品”的工作：文字、画面、美感、声音、情绪共鸣…这些都是你能收钱的能力。\n你赚钱的起点不是逻辑，而是你传递出来的情绪与氛围。",
      earning_methods:
        "疗愈类课程／文艺内容（绘画、写作、短片）／情感共鸣社群经营／美感型设计／配乐／插画",
      financial_risks: "情绪影响收支节奏／接案型容易高低起伏大",
      focus_areas: "建立“感性产出结构化系统”：打造情绪能卖钱的产品线",
      quote: "You can make money because you can move people.",
    },
    官禄宫: {
      title: "🎼 文曲（官禄宫）｜感性艺术星",
      description:
        "你适合在“情绪引导＋美学表达＋疗愈场域”里发光，是艺术创作人、疗愈导师、美学顾问等最好的人选。\n别人靠系统执行任务，你靠“感动人”让客户回头。",
      career_traits:
        "艺术创作人／心理咨询／身心灵导师／品牌视觉顾问／美学策划人／内容IP打造者",
      career_pitfalls: "情绪管理影响项目交付／完美主义／难以与团队系统节奏配合",
      focus_areas: "结合“结构型合伙人”，把你的灵感转化为实际可售产品或服务",
      quote:
        "You are not a worker, you are a person who perceives the world and creates energy through art.",
    },
  },
  文昌: {
    type: "逻辑表达星",
    label: "🧾 思维组织者 ｜知识结构导师",
    命宫: {
      title: "✍️ 文昌（命宫）｜逻辑表达星",
      description:
        "你是理性派的表达者，思路清晰，逻辑严谨，适合教学、研究、写作等需要组织性强的领域。\n你的优势在于“讲得懂＋写得清”，别人绕圈时，你能一语道破。",
      strengths:
        "Clear and logical thinker, Highly organized, Proficient in structured writing, Responds swiftly and accurately, Detail-oriented",
      cautions: "Overly rigid",

      next_focus: "让表达更接地气／不要怕重复／一支笔可以换一座山",
      quote:
        "You are not a talkative person, you are a person who makes the world understand.",
    },
    财帛宫: {
      title: "✍️ 文昌（财帛宫）｜逻辑表达星",
      description:
        "你擅长“讲清楚、讲对点”，最适合用知识变现、用文字建构信任系统。你会因为逻辑清晰、系统完整而被客户信任、愿意付费。\n你靠“知识＋表达＋结构”吸金，不靠声量靠内容力。",
      earning_methods:
        "专业内容整理、课程架构、教育产品、策略型咨询、写作变现、线上知识产品",
      financial_risks: "太过理性压抑消费、过度花时间优化系统反而错失入金节奏",
      focus_areas: "提升内容变现速度、打造一套“有结构的知识型产品”并持续销售",
      quote:
        "You make money not by luck, but by making people understand how much you are worth.",
    },
    官禄宫: {
      title: "✍️ 文昌（官禄宫）｜逻辑表达星",
      description:
        "你适合在“信息组织”、“内容分析”、“系统输出”的场域中工作，是企划脑、教学魂、表达型人才中的结构专家。\n别人开会讨论到天荒地老时，你已经整理好PPT＋流程图＋执行方向了。",
      career_traits:
        "教学讲师、企划撰写、职能训练、教育系统设计、品牌架构师、SEO文案／系统顾问",
      career_pitfalls: "太在意小细节／拖延症发作／完成度永远不满意",
      focus_areas: "练习“80分就推”、“内容先上线再优化”，让你的知识真正开始变现",
      quote:
        "You are not a knowledge-based employee, you are the center of a business that simplifies complexity.",
    },
  },
  贪狼: {
    type: "魅力星",
    label: "🐺 风格吸金者 ｜多栖能量玩家",
    命宫: {
      title: "🐺 贪狼（命宫）｜魅力星",
      description:
        "你是命盘里“最懂得玩”的人。你多才多艺、多变多面，吸引力强，有创造力与极高的人际磁场。",
      strengths:
        "Highly charismatic, Naturally social, Excels in creative self-expression, Deeply attuned to sensory details, Engaging and magnetic presence",
      cautions: "Easily distracted, Conflicted",

      next_focus: "专注做出一个让你“又爱又赢”的系统，不再只是体验而已",
      quote:
        "You are not a person who plays a lot, you are the king who can turn happiness into a profession.",
    },
    财帛宫: {
      title: "🐺 贪狼（财帛宫）｜魅力星",
      description:
        "你的赚钱方式必须带感官体验、独特魅力、自由度。你不适合死板套路，更适合靠“个人风格”吸钱。",
      earning_methods: "娱乐产业／美业／风格自媒体／感官体验式生意／销售高手",
      financial_risks: "太想花、赚钱也快花得快、赚多但无节制留不住",
      focus_areas: "打造独特个性变现系统／设定赚钱纪律／找理性合伙人做后盾",
      quote: "Your style is the most profitable brand.",
    },
    官禄宫: {
      title: "🐺 贪狼（官禄宫）｜魅力星",
      description:
        "你适合在“舞台感强”的场域发光，越能自由表达、越能跟人互动，你越能爆发出赚钱与影响力的双重威力。\n你不是来朝九晚五坐办公室的，你是来让别人被你感染、跟你一起high的。",
      career_traits:
        "演艺／直播／行销／公关／娱乐主持／业务销售／活动策划／创意副业",
      career_pitfalls: "太看心情工作／难维持长线专注／常因关系搞砸合作",
      focus_areas: "建立“玩中赢”系统，让创意有结构、情绪有出口、事业有节奏",
      quote:
        "You are not here to work overtime, you are here to make people remember who you are.",
    },
  },
  太阳: {
    type: "领导星",
    label: "🌞 使命点灯人 ｜影响力唤醒者",
    命宫: {
      title: "🌞 太阳（命宫）｜领导星",
      description:
        "你是来发光的。你身上有一种天生的温暖、领导气场与承担力。别人犹豫时，你已经点燃自己照亮别人。",
      strengths:
        "Decisive under pressure, Deeply responsible, Grounded in strong principles, Natural leadership ability, Guided by a compelling vision",
      cautions: "Overgiving, Guarded",
      quote:
        "You are not a person who lights up the world, you are also worth being lit.",
    },
    财帛宫: {
      title: "🌞 太阳（财帛宫）｜领导星",
      description:
        "你最适合靠“带动＋影响力＋公开表达”赚钱。你不该藏着做，而是站出来带大家做。\n你的钱来自你“照亮别人”的能力：客户因为你变得有方向，就会掏钱跟你走。",
      earning_methods:
        "培训导师／顾问讲师／业务主导／高曝光个人品牌／直播／公开演讲／销售领袖",
      financial_risks: "过度付出、定价偏低、怕别人负担不敢报价",
      focus_areas: "练习带出价值感的主张／敢亮出价格与框架／定时回收信任红利",
      quote:
        "You are not here to sell products, you are here to ignite the source of trust.",
    },
    官禄宫: {
      title: "🌞 太阳（官禄宫）｜领导星",
      description:
        "你适合站在“前线与发声”的位置：你是团体里的主将、舞台上的主讲、社群里的主脑。\n你越能扛责任，越能赢得社会地位与资源配对。",
      career_traits: "创业领袖／教育培训／营销顾问／政治／公益／社群主理人",
      career_pitfalls: "怕求助／好强不肯放手／坚持旧方式不更新",
      focus_areas: "打造带人系统／建立“领导力赢利方程式”",
      quote:
        "You are not an employee, you are the light that leads everyone forward.",
    },
  },
  太阴: {
    type: "内在温柔星",
    label: "🌙 治愈守护者 ｜情绪稳流操盘手",
    命宫: {
      title: "🌙 太阴（命宫）｜内在温柔星",
      description:
        "你是安静的力量，是默默观察、稳定输出、从细节中见深度的人。你拥有强大的情感洞察力，是天生的倾听者与照顾者。",
      strengths:
        "Delicate, Gentle, Calm And Patient, Thoughtful, Emotionally Balanced",
      cautions: "Emotion-Suppressing, Overaccommodating, Conflict-Averse",
      quote: "You are not fragile, you are the ocean of deep inner energy.",
    },
    财帛宫: {
      title: "🌙 太阴（财帛宫）｜内在温柔星",
      description:
        "你适合“温暖型财富管道”：不是冲业绩型，而是“长期信任型”。你靠细腻服务、长期经营、低调稳定赚钱。",
      earning_methods:
        "客户管理／家庭教育／照护产业／投资理财顾问／女性创业／疗愈型服务",
      financial_risks: "容易被情感带走、怕要价、常常帮太多不该帮的人",
      focus_areas: "建立服务结构／打造长期稳定客户池／设定定价底线",
      quote:
        "Your gentleness can make money, as long as you learn to set a price for yourself.",
    },
    官禄宫: {
      title: "🌙 太阴（官禄宫）｜内在温柔星",
      description:
        "你适合走“稳定深耕路线”的事业：你做得慢，但一旦进入状态，就能做得深、做得久、做到令人感动。",
      career_traits: "教育／金融／照护／文创／家庭／心理／品牌幕僚",
      career_pitfalls: "缺乏曝光、不敢推自己、容易被看轻",
      focus_areas: "打造专业定位／练习“温和地表达野心”",
      quote:
        "You are not without ambition, you just conquer the world in the most gentle way.",
    },
  },
  巨门: {
    type: "说话能量星",
    label: "🗣 洞察唤醒者 ｜语言转化行者",
    命宫: {
      title: "🌪️ 巨门（命宫）｜说话能量星",
      description:
        "你是思辨型人格，常常一语戳破重点，带有强烈的洞察与“敢说真话”的气场。你的话术强、逻辑力高，是打破假象的人。",
      strengths:
        "Boldly Honest, Logical Thinker, Highly Observant, Impactful Communicator, Direct and Clear",
      cautions: "Misinterpreted, Blunt",

      quote: "You are not a quarrel king, you are the antidote of language.",
    },
    财帛宫: {
      title: "🌪️ 巨门（财帛宫）｜说话能量星",
      description:
        "你最适合靠“沟通力＋洞察力”赚钱，不是圆滑，而是讲出别人不敢讲的真实，打造深度内容、尖锐品牌。",
      earning_methods: "深度访谈／心灵咨询／品牌策略／犀利文案／犀利自媒体",
      financial_risks: "说得多做得少、表达越界失客户",
      focus_areas: "打造“敢说真话的变现模型”，建立高信任社群",
      quote: "You are not a quarrel king, you are the antidote of language.",
    },
    官禄宫: {
      title: "🌪️ 巨门（官禄宫）｜说话能量星",
      description:
        "你适合说故事、讲真话、带思辨：尤其适合做“揭露型／教育型／洞察型”的事业。",
      career_traits:
        "社群主理人／资深讲者／心理系导师／品牌操盘人／思辨平台主持",
      career_pitfalls: "表达太快团队跟不上／做事风格难被理解",
      focus_areas: "团队搭配表达者＋执行者＋信任构建者",
      quote: "You are not necessarily liked, but you are worth being trusted.",
    },
  },
  天同: {
    type: "天真疗愈星",
    label: "🍀 共情陪伴者 ｜信任养成大师",
    命宫: {
      title: "🍀 天同（命宫）｜天真疗愈星",
      description:
        "你是“世界的疗愈剂”，内在柔软、有同理心，喜欢和善、讨厌冲突，是温柔但坚定的理想主义者。\n你渴望世界更好，而你也会用行动慢慢修补它。",
      strengths:
        "Positive-Minded, Empathetic, Peacemaker, Gentle And Accepting, Healing Presence",
      cautions: "Conflict-Avoidant, Withdrawing, Approval-Seeking",

      quote:
        "You are not weak, you are the light person who can overcome the hard with gentleness.",
    },
    财帛宫: {
      title: "🍀 天同（财帛宫）｜天真疗愈星",
      description:
        "你适合“关系型赚钱”：靠陪伴、靠温度、靠感觉让客户安心。你不爱硬推，但你的细水长流却能培养出死忠客户。",
      earning_methods:
        "咨询辅导／身心疗愈／亲子教育／服务业／顾问陪跑型方案／社群陪伴服务",
      financial_risks: "怕报价／给太多免费价值／靠感情撑服务",
      focus_areas: "建立“疗愈型服务收费模型”，把温柔定价，让温暖变被动收入",
      quote:
        "You are a soft person who can make money, but gentleness cannot be free anymore.",
    },
    官禄宫: {
      title: "🍀 天同（官禄宫）｜天真疗愈星",
      description:
        "你适合走“温和又有影响力”的路线，教育、心理、亲子、人资、陪伴辅导等，都适合你稳定发展、慢慢累积信任。",
      career_traits:
        "教育培训／心理咨询／儿童产业／人资导师／陪跑型教练／社群文化主理人",
      career_pitfalls: "太不主动就被边缘化／怕冲突就不争取机会",
      focus_areas: "把你的温柔建立成“影响力系统”，让安静的你也能稳收事业红利",
      quote:
        "You don't win the world by shouting, you win it by trust and depth.",
    },
  },
  七杀: {
    type: "行动破格星",
    label: "🗡 快速破局者 ｜极限挑战操手",
    命宫: {
      title: "🗡 七杀（命宫）｜行动破格星",
      description:
        "你是天生的突破者、不走寻常路的先锋军。你天生带着“不爽就改、不对就拆”的霸气，别人犹豫的时候你已经冲上战场。",
      strengths:
        "Action-Oriented, Decisive, Independent, Risk-Taking, Innovation-Driven",
      cautions: "Overpaces Others, Emotionally Volatile, Energy-Crashing",
      quote:
        "You are not a bad temper, you are the engineer of fate who comes with a knife.",
    },
    财帛宫: {
      title: "🗡 七杀（财帛宫）｜行动破格星",
      description:
        "你适合靠“速度＋胆识＋敢抢先机”来赚钱，投机型、趋势型、爆发型机会最适合你，只要你控制住风险。",
      earning_methods:
        "投资交易／新创项目／快销产品／趋势第一波／数字货币／技术操盘",
      financial_risks: "贪快／管不住手／情绪交易",
      focus_areas: "打造“快而稳”的金流策略、练习止盈纪律、带团队控节奏",
      quote:
        "You are the money-making突击手 in the battlefield, not the always冲锋的炮灰.",
    },
    官禄宫: {
      title: "🗡 七杀（官禄宫）｜行动破格星",
      description:
        "你适合走“自由自主、弹性大、主导性高”的职业，必须给你空间、目标、挑战，不然你会厌世。",
      career_traits: "创业／接案型工作／品牌打造／风险项目负责人／先行者型顾问",
      career_pitfalls: "难融入团队文化／太强调自由／带不住人",
      focus_areas: "建立可传承系统／打造“自由有边界”的个人品牌",
      quote:
        "You are not a person in the system, you are here to create a new system.",
    },
  },
  破军: {
    type: "破局重生星",
    label: "🌊 重启革新者 ｜混乱转金术士",
    命宫: {
      title: "🌊 破军（命宫）｜重生星",
      description:
        "You are a soul-type personality who constantly breaks and rebuilds yourself. You don't live easily, but every turn is ten times more精彩。You are not afraid to lose, you are afraid of being too predictable.",
      strengths:
        "Trailblazing, Highly Adaptable, Reform-Driven, Naturally Dynamic, Change-Oriented",
      cautions: "Self-Sabotaging, Past-Rejecting, Unstable",

      quote:
        "You are not always restarting, you are creating the strongest version of yourself.",
    },
    财帛宫: {
      title: "🌊 破军（财帛宫）｜重生星",
      description:
        "你适合走“先乱再稳”型赚钱路线，冲劲强、敢拼、敢破，适合投身趋势波动大、竞争高、更新快的行业。",
      earning_methods:
        "创业型产品／投机市场／社交媒体内容／网红流量转化／新平台吃红利",
      financial_risks: "反复换方向、没收口系统、看太大做太慢",
      focus_areas: "建立“短打赢收口”流程／打造多渠道流量变现系统",
      quote:
        "You are here to turn chaos into a gold mine, not to be swallowed by change.",
    },
    官禄宫: {
      title: "🌊 破军（官禄宫）｜重生星",
      description:
        "你不适合稳定工作，你适合“干一票大的”：事业必须有成长性、有升级感、有挑战性，越打破规则越有动力。",
      career_traits:
        "自媒体／内容创作者／斜杠型创业者／线上平台主理人／创意实验性产品主脑",
      career_pitfalls: "没稳定系统／易被误解为不靠谱／团队难配合你节奏",
      focus_areas: "打造“破局→变现→带人”三部曲结构，放大独特风格变资产",
      quote:
        "You are not an employee, you are a warrior who is always ready to overthrow the old system.",
    },
  },
  左輔: {
    type: "辅佐星",
    label: "🫱 忠诚辅助者 ｜温暖可靠的左膀右臂",
    命宫: {
      title: "🫱 左輔（命宫）｜辅佐星",
      description:
        "你天生给人安全感，是团队中最可靠的存在。你擅长倾听、扶持、补位，是领导信赖的左膀右臂。",
      strengths: "Loyal, Gentle, Helpful, Supportive, Dependable",
      cautions: "Self-Sacrificing, Unassertive",

      next_focus: "学习设界限，在给予中不失自我",
      quote: "Your value is in supporting the whole team silently.",
    },
    财帛宫: {
      title: "🫱 左輔（财帛宫）",
      description: "你擅长通过协助他人、团队合作、幕后支援来获得财富。",
      earning_methods: "服务支持、行政协助、人资团队",
      financial_risks: "过度付出，回报不对等",
      focus_areas: "设好合作条件，争取应得报酬",
      quote: "Your wealth comes from win-win, not from winning alone.",
    },
    官禄宫: {
      title: "🫱 左輔（官禄宫）｜辅佐星",
      description:
        "你适合在组织中担任协调、顾问、辅佐的角色，是不可替代的支持者。",
      career_traits: "团队管理、执行协助、项目协调",
      career_pitfalls: "缺乏个人声音，容易被忽视",
      focus_areas: "提升专业能力，发出你的影响力",
      quote:
        "You are the backbone of the protagonist, also the soul of the stage.",
    },
  },
  右弼: {
    type: "辅佐星",
    label: "🤝 圆融智辅者 ｜温润如玉的关系建构师",
    命宫: {
      title: "🤝 右弼（命宫）｜辅佐星",
      description: "你为人亲切、擅长调和人际关系，是让团队更和谐的粘合剂。",
      strengths:
        "Diplomatic, Sociable, Reliable, Graceful Under Pressure, Cooperative",
      cautions: "Approval-Seeking, Self-Neglecting",

      next_focus: "学会表达真实感受，平衡自己与他人",
      quote:
        "You are not an accessory, but a lubricant that makes everything smoother.",
    },
    财帛宫: {
      title: "🤝 右弼（财帛宫）",
      description: "你适合靠人脉、关系经营、合作共赢来创造财富。",
      earning_methods: "品牌合作、公关关系、人际销售",
      financial_risks: "人情债过多，导致资源流失",
      focus_areas: "建立清晰界限，资源换位合理",
      quote: "Your relationships are your capital.",
    },
    官禄宫: {
      title: "🤝 右弼（官禄宫）｜辅佐星",
      description: "你适合担任公共关系、协调角色，是团队与外界的重要桥梁。",
      career_traits: "公关、协调、客户成功",
      career_pitfalls: "容易被情绪左右，影响判断",
      focus_areas: "练习理性表达，做出理智决策",
      quote:
        "You make cooperation more warm, and make achievements more visible.",
    },
  },
  天梁: {
    type: "辅佐星",
    label: "🧱 守护公正者 ｜包容力与正义感的代表",
    命宫: {
      title: "🧱 天梁（命宫）｜辅佐星",
      description:
        "你天生有责任感，具有公理与同理心，是团队中守护者的角色，擅长安抚与解决冲突。",
      strengths:
        "Justice-Oriented, Compassionate, Nurturing, Healing Presence, Emotionally Supportive",
      cautions: "Overburdened, Overresponsible",

      next_focus: "学会区分责任界线，不为所有人负责",
      quote:
        "Your kindness is not weakness, but the strongest armor in your energy field.",
    },
    财帛宫: {
      title: "🧱 天梁（财帛宫）",
      description:
        "你适合从事服务性、公益性、疗愈性质的财富路径，赚钱带有使命感。",
      earning_methods: "心理咨询、教育培训、公益医疗",
      financial_risks: "过于理想化，缺乏金钱意识",
      focus_areas: "在利他中学会定价，让价值被看见",
      quote: "Helping others is also a way to achieve wealth for you.",
    },
    官禄宫: {
      title: "🧱 天梁（官禄宫）｜辅佐星",
      description: "你适合成为导师、顾问、长辈型角色，在组织中以德服人。",
      career_traits: "顾问、导师、医疗健康、公职体系",
      career_pitfalls: "过于宽容，放任问题扩大",
      focus_areas: "增强决断力，守护也能立威",
      quote:
        "Your authority comes from your virtue, and you are the mountain of security for the team.",
    },
  },
  廉贞: {
    type: "斗志星",
    label: "🔥 规则挑战者 ｜野心与魅力的结合体",
    命宫: {
      title: "🔥 廉贞（命宫）｜斗志星",
      description:
        "你充满斗志、外冷内热，是带点叛逆的领袖人格。擅长突破框架，挑战权威。",
      strengths:
        "Decisive, Charismatic, Ambitious, Vision-Driven, Confident Leader",
      cautions: "Stubborn, Self-Opinionated, Emotionally Unsteady",

      next_focus: "整合情绪与行动，让锋芒更有方向",
      quote:
        "You are not here to adapt to the world, you are here to change the rules.",
    },
    财帛宫: {
      title: "🔥 廉贞（财帛宫）",
      description: "你适合靠策略布局、品牌经营、权谋思维来创造价值。",
      earning_methods: "权力运作、策略创业、品牌经营",
      financial_risks: "短视近利、好高骛远",
      focus_areas: "培养长期思维，累积稳健资产",
      quote: "Your ambition is worth the resources.",
    },
    官禄宫: {
      title: "🔥 廉贞（官禄宫）｜斗志星",
      description:
        "You are suitable for a career that requires power and rules, and you are the person who changes the game rules.",
      career_traits: "Strategy官、改革推动者、领导者",
      career_pitfalls: "太过强势，易树敌",
      focus_areas: "融入团队，激烈中保留圆润",
      quote: "You drive change, and can also stabilize the whole situation.",
    },
  },
};

export const TIP_CONSTANTS = {
  命宫: {
    紫微: "学习做决策，用稳定的心养稳团队",
    天府: "在稳定的基础上，尝试创新和突破",
    天相: "在协调他人的同时，关注自身需求",
    武曲: "学习适度柔软，你的价值不只是做完任务，还要被看见、被珍惜",
    天机: "开始执行比思考更重要，练习让一个想法跑到终点",
    文曲: "培养稳定输出能力／情绪不再控制你，而是被你转化成灵感",
    文昌: "让表达更接地气／不要怕重复／一支笔可以换一座山",
    贪狼: "专注做出一个让你又爱又赢的系统，不再只是体验而已",
    太阳: "你不是一个人照亮世界的人，你也值得被别人照亮",
    太阴: "你不是脆弱，你是内在深不可测的能量海",
    巨门: "你不是吵架王，你是语言的解毒剂",
    天同: "你不是软弱，你是以柔克刚的光之人",
    七杀: "你不是坏脾气，你是带着刀锋来的命运工程师",
    破军: "你不是一直在重启，而是在打造最强版本的自己",
    左輔: "学习设界限，在给予中不失自我",
    右弼: "学会表达真实感受，平衡自己与他人",
    天梁: "学会区分责任界线，不为所有人负责",
    廉贞: "整合情绪与行动，让锋芒更有方向",
  },
  财帛宫: {
    紫微: "多管道收入／组团队赚钱／建立金钱系统",
    天府: "在稳健的基础上，适度冒险，抓住机会",
    天相: "清楚表达价值／创造信任通路／定价别再退",
    武曲: "建立属于自己的「高价服务系统」，提升每小时单位产值",
    天机: "选一个最有机会长期跑赢的方向深耕，别把能量分给太多细枝末节",
    文曲: "建立感性产出结构化系统：打造情绪能卖钱的产品线",
    文昌: "提升内容变现速度、打造一套有结构的知识型产品并持续销售",
    贪狼: "打造独特个性变现系统／设定赚钱纪律／找理性合伙人做后盾",
    太阳: "练习带出价值感的主张／敢亮出价格与框架／定时回收信任红利",
    太阴: "建立服务结构／打造长期稳定客户池／设定定价底线",
    巨门: "打造敢说真话的变现模型，建立高信任社群",
    天同: "建立疗愈型服务收费模型，把温柔定价，让温暖变被动收入",
    七杀: "打造快而稳的金流策略、练习止盈纪律、带团队控节奏",
    破军: "建立短打赢收口流程／打造多渠道流量变现系统",
    左輔: "设好合作条件，争取应得报酬",
    右弼: "建立清晰界限，资源换位合理",
    天梁: "在利他中学会定价，让价值被看见",
    廉贞: "培养长期思维，累积稳健资产",
  },
  官禄宫: {
    紫微: "建立权威的同时，注重团队建设和协作",
    天府: "在稳定的基础上，尝试创新和突破",
    天相: "练习边界感／明确职掌与KPI／打造可复制的协作模式",
    武曲: "打造「带人系统」而不是「做事系统」，让你从个人强转团队强",
    天机: "搭配表达型合伙人／打造个人策略品牌／建立高单价智力服务系统",
    文曲: "结合结构型合伙人，把你的灵感转化为实际可售产品或服务",
    文昌: "练习80分就推、内容先上线再优化，让你的知识真正开始变现",
    贪狼: "建立玩中赢系统，让创意有结构、情绪有出口、事业有节奏",
    太阳: "打造带人系统／建立领导力赢利方程式",
    太阴: "打造专业定位／练习温和地表达野心",
    巨门: "团队搭配表达者＋执行者＋信任构建者",
    天同: "把你的温柔建立成影响力系统，让安静的你也能稳收事业红利",
    七杀: "建立可传承系统／打造自由有边界个人品牌",
    破军: "打造破局→变现→带人三部曲结构，放大独特风格变资产",
    左輔: "提升专业能力，发出你的影响力",
    右弼: "练习理性表达，做出理智决策",
    天梁: "增强决断力，守护也能立威",
    廉贞: "融入团队，激烈中保留圆润",
  },
};

export const STRENGTH_CONSTANTS = {
  紫微: ["气场强", "爱负责", "有统筹力"],
  天府: ["稳重", "可靠", "管理能力强"],
  天相: ["温和", "善于协调", "人际关系好"],
  武曲: ["高执行力", "有纪律", "踏实不虚", "目标导向强"],
  天机: ["反应快", "思考深", "策略性强", "灵活不僵化"],
  文曲: ["情绪细腻", "创意强", "艺术细胞高", "写得动人"],
  文昌: ["脑子清楚", "讲得有条理", "文笔扎实", "反应快"],
  贪狼: ["魅力值高", "社交高手", "善于创意表现与感官体验"],
  太阳: ["有魄力", "有责任感", "正义感强", "能带人", "有愿景"],
  太阴: ["细腻", "温柔", "温和耐心", "思虑周全", "情绪调和力强"],
  巨门: ["敢讲实话", "逻辑清晰", "观察力强", "表达有杀伤力"],
  天同: ["心态正向", "善解人意", "和平使者", "温柔包容", "有疗愈力"],
  七杀: ["执行爆发力强", "果决", "独立", "敢冒险", "创新破局"],
  破军: ["破旧立新力强", "适应力强", "有改革能量", "天生带冲劲"],
  左輔: ["忠诚", "温和", "乐于助人"],
  右弼: ["圆融", "善交际", "可靠"],
  天梁: ["正义感强", "包容", "有医护能量"],
  廉贞: ["果断", "有魅力", "有野心"],
};
